import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Typography, Paper, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import IconRadiusButton from '../CustomizedUIs/IconRadiusButton';
import Arrow from '../assets/icons/primary-blue-arrow-right.png';
import { baseAuthUrl } from '../authProvider';
import icBackground from '../assets/icons/root_file_manager.png';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        paddingLeft: theme.spacing(4.5),
        paddingRight: theme.spacing(4.5),
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(2),
        cursor: 'pointer',
        transition: '0.2s',
        boxShadow: 'none',

        '&::active': {
            opacity: 0.5
        },
        '&:active': {
            opacity: 0.5
        }
    },
    control: {
        padding: theme.spacing(2),
    },
    image: {
        width: 153,
        height: 120,
        marginBottom: theme.spacing(2.5),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    imageIcon: {
        position: 'absolute',
        width: 30,
        height: 30,
        top: 54,
        left: 60
    },
    titleName: {
        fontFamily: "UniviaPro",
        fontSize: "13px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.25,
        letterSpacing: " 0.13px",
    },
    CategoryName: {
        fontFamily: "UniviaPro-Medium",
        fontSize: "18px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
    }, btnArrow: {
        width: "20px",
        height: "20px",
        fontSize: '11px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        background: '#e5f1f8',
        borderRadius: '15px'
    }
}));

function Index({ category, getCategory }) {
    const classes = useStyles();
    const categories = category.categories ? category.categories : [];

    return (
        <Fragment>
            <Typography className={classes.CategoryName} style={{ marginBottom: 32 }}>{category.name}</Typography>
            <Box display="flex" justifyContent="space-between">
                {categories.map(item => (
                    <Paper className={classes.paper} onClick={() => getCategory(item.id)} key={item.id + ''}>
                        <Box style={{ position: 'relative' }}>
                            <img alt="" src={icBackground} className={classes.image} />
                            <img alt="" className={classes.imageIcon} src={baseAuthUrl + '/' + item.iconURL} />
                        </Box>
                        <Box display="flex" justifyContent="flex-start" alignItems="center">
                            <Typography className={classes.titleName}>{item.name}</Typography>
                            <IconRadiusButton
                                className={classes.btnArrow}
                                style={{ color: '#237FC2', padding: 2, marginLeft: 8, width: 20, height: 20, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                onClick={() => { }}
                            >
                                <img src={Arrow} style={{ width: "14.9px", height: "14.8px" }} />
                            </IconRadiusButton>
                        </Box>
                    </Paper>
                ))}
            </Box>
        </Fragment>
    );
}

Index.propTypes = {
    category: PropTypes.object,
    getCategory: PropTypes.func.isRequired
}

export default Index;
